import { render, staticRenderFns } from "./FieldLinkSimple.vue?vue&type=template&id=53b6e0c9&scoped=true"
import script from "./FieldLinkSimple.vue?vue&type=script&lang=js"
export * from "./FieldLinkSimple.vue?vue&type=script&lang=js"
import style0 from "./FieldLinkSimple.vue?vue&type=style&index=0&id=53b6e0c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b6e0c9",
  null
  
)

export default component.exports